module.exports = __webpack_public_path__ + "img/title-bg.5b7302d1.png";